import React from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';

export default function LocationType(props) {

    const locationType =  props.dataSet[props.dataKey];
    let valueObject = [];
    
    if(locationType && typeof locationType === 'string'){
        valueObject = LocationTypeList.find(cobj => cobj.value.toLowerCase() === props.dataSet[props.dataKey].toLowerCase());

    }

    return (
        <ValidatingInput
            label={props.label}
            dataSet={props.dataSet}
            dataKey={props.dataKey}
            valueObject={valueObject}
            onChange={props.onChange}
            options={LocationTypeList}
            validationFn={(val) => {
                return LocationTypeList.findIndex(co=>co.value === val.value) > -1
            }}
            validationType="select"
        />
    );
}

const LocationTypeList = [
    { label: 'Building', value: 'Building' },
    { label: 'City', value: 'City' },
    { label: 'Closet', value: 'Closet' },
    { label: 'Country', value: 'Country' },
    { label: 'District', value: 'District' },
    { label: 'Floor', value: 'Floor' },
    { label: 'Fridge', value: 'Fridge' },
    // { label: 'IVMI Cabinet', value: 'ivmi_cabinet' },
    { label: 'Mall', value: 'Mall' },
    { label: 'Mill', value: 'Mill' },
    { label: 'Port', value: 'Port' },
    { label: 'Office', value: 'Office' },
    { label: 'Room', value: 'Room' },
    { label: 'Section', value: 'Section' },
    { label: 'Shelf', value: 'Shelf' },
    { label: 'Shop', value: 'Shop' },
    { label: 'Site', value: 'Site' },
    { label: 'Vessel', value: 'Vessel' },
];
